function hasMembers(hasCouple, couple) {
  return Boolean(hasCouple && couple && Array.isArray(couple.members));
}

export function getActivePartner(couple, hasCouple, currentUser) {
  if (!hasMembers(hasCouple, couple)) {
    return null;
  }

  return couple.members.find(
    (member) => member.userId._id !== currentUser?.id && member.status === "active"
  );
}

export function getActivePartnerCount(couple, hasCouple) {
  if (!hasMembers(hasCouple, couple)) {
    return 0;
  }

  return couple.members.filter((member) => member.status === "active").length;
}

export function getCoupleAge(couple, hasCouple) {
  if (!hasCouple || !couple || !couple.relationshipStartDate) {
    return null;
  }

  const startDate = new Date(couple.relationshipStartDate);
  const now = new Date();
  const diffInMs = now - startDate;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return {
    days: diffInDays,
    months: Math.floor(diffInDays / 30),
    years: Math.floor(diffInDays / 365),
  };
}

export function formatCoupleAge(age) {
  if (!age) {
    return "Nao informado";
  }

  if (age.years > 0) {
    return `${age.years} ano${age.years > 1 ? "s" : ""}`;
  }

  if (age.months > 0) {
    return `${age.months} mes${age.months > 1 ? "es" : ""}`;
  }

  return `${age.days} dia${age.days > 1 ? "s" : ""}`;
}
